import React from 'react';
import { withFeatureToggle } from './feature-toggle.hocs';
import { isDataLoading } from '../../shared/utils/redux.utils';
import { getComponent } from './feature-toggle.utils';
import { FeatureToggleProps } from './feature-toggle.utility-types';

const defaultProps = {
    extraProps: {},
    replacement: null,
};

const FeatureToggleImpl = ({
    featureToggle, feature, target, replacement, ...extraProps
}: FeatureToggleProps) => {
    if (isDataLoading(featureToggle.loadState)) return null;
    const { features: userFeatures } = featureToggle.data;
    const Component = getComponent(userFeatures, feature, target, replacement);
    return Component ? (
        <Component {...extraProps} />
    ) : null;
};

FeatureToggleImpl.defaultProps = defaultProps;

export const FeatureToggle = withFeatureToggle(FeatureToggleImpl);
/**
 * @deprecated Use nominal export
 */
export default FeatureToggle;
